/**
 * @author zch
 * @date  2023-10-04
 * @description 校正windows页面在系统进行缩放后导致页面被放大的问题，通常放大比例是125%、150%
 * **/


function calculateZoomForResolution(designWidth, designHeight) {
	// 获取设计稿的宽度和高度
	let designSize = Math.min(designWidth, designHeight);

	// 获取当前屏幕的宽度和高度，考虑到设备像素比率
	let screenWidth = window.screen.width * window.devicePixelRatio;
	let screenHeight = window.screen.height * window.devicePixelRatio;

	// 获取文档的可视宽度和高度
	let documentWidth = document.documentElement.clientWidth;
	let documentHeight = document.documentElement.clientHeight;

	// 考虑系统缩放比例
	let systemZoom = 1 / window.devicePixelRatio;

	// 计算宽度和高度的缩放比例
	let widthScale = screenWidth / designWidth;
	let heightScale = screenHeight / designHeight;
  console.log(widthScale)
  console.log(heightScale)
	let sizeScale = Math.min(widthScale, heightScale) * systemZoom;

	// 根据实际情况进行微调
	// 例如，可以根据屏幕宽度、响应式设计等因素进行调整

	return sizeScale; // 将比例转换为百分比
}



class DevicePixelRatio {
	constructor() {
		//this.flag = false;
	}
	//获取系统类型
	_getSystem() {
		let flag = false;
		var agent = navigator.userAgent.toLowerCase();
		//		var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
		//		if(isMac) {
		//			return false;
		//		}
		//现只针对windows处理，其它系统暂无该情况，如有，继续在此添加
		if (agent.indexOf("windows") >= 0) {
			return true;
		}
	}
	//获取页面缩放比例
	//	_getDevicePixelRatio() {
	//		let t = this;
	//	}
	//监听方法兼容写法
	_addHandler(element, type, handler) {
		if(element.addEventListener) {
			element.addEventListener(type, handler, false);
		} else if(element.attachEvent) {
			element.attachEvent("on" + type, handler);
		} else {
			element["on" + type] = handler;
		}
	}
	//校正浏览器缩放比例
	_correct() {
		let t = this
		let setZoom = 1

		setZoom = calculateZoomForResolution(1680, 900) // 设计稿比例
		setZoom = setZoom - 0.07

		// 在body上操作缩小会导致整个网页有留白
		if (setZoom > 1) {
			const layoutContentDiv = document.getElementsByTagName('body')[0]
			if (layoutContentDiv) {
				layoutContentDiv.style.zoom = setZoom
			}
		} else {
			if (setZoom < 0.66) {
				setZoom = 0.66
			}
			const layoutContentDiv = document.querySelector("#app")
			if (layoutContentDiv) {
				layoutContentDiv.style.zoom = setZoom
			}
		}
	}
	//监听页面缩放
	_watch() {
		let t = this;
		t._addHandler(window, 'resize', function() {
      //注意这个方法是解决全局有两个window.resize
			//重新校正
			t._correct()
		})
	}
	//初始化页面比例
	init() {
		let t = this;
		if(t._getSystem()) { //判断设备，目前只在windows系统下校正浏览器缩放比例
			//初始化页面校正浏览器缩放比例
			t._correct();
			//开启监听页面缩放
			t._watch();
		} else {
			let setZoom = 1

			setZoom = calculateZoomForResolution(1680, 900) // 设计稿比例
			setZoom = setZoom - 0.07

			// 在body上操作缩小会导致整个网页有留白
			if (setZoom > 1) {
				const layoutContentDiv = document.getElementsByTagName('body')[0]
				if (layoutContentDiv) {
					layoutContentDiv.style.zoom = setZoom
				}
			} else {
				if (setZoom < 0.66) {
					setZoom = 0.66
				}
				const layoutContentDiv = document.querySelector("#app")
				if (layoutContentDiv) {
					layoutContentDiv.style.zoom = setZoom
				}
			}
		}
	}
}
export default DevicePixelRatio;



// WEBPACK FOOTER //
// ./src/util/devicePixelRatio.js